import {
    getConnection,
    getCurSession,
    getStatusID,
    setIsBPMChanged
} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {buildServerCall} from '../../../../../services/wcfService';
import {BpmAlertResponse} from './types';
import {handleBPMMessages} from '../utils/handlePermission';
import {bpmRulesStorage} from '../BPM.rules.storage';

export const bpmCopyRule = async (alertNumber: string, fromStatus: string, toStatus: string) => {
    const methodName = 'BPMAlertCopy';
    const reason = 'BPMAlertCopy';

    const fromid = getStatusID(fromStatus)?.toString();
    const toid = getStatusID(toStatus)?.toString();

    const parameters = {
        session: [getCurSession()],
        alert: [alertNumber],
        fromid: [fromid],
        toid: [toid]
    };

    const res: BpmAlertResponse = await buildServerCall(
        methodName,
        parameters,
        reason,
        true,
        getConnection
    );

    const BPM = res?.BPM?.[0];
    const rules = BPM?.Rules?.[0].Rule;

    const isOK = handleBPMMessages(BPM);

    if (!isOK) return null;

    // Triggers GWT state change flag
    setIsBPMChanged(true);

    const storageData = bpmRulesStorage.getStorage(getCurSession());
    storageData.setRules(fromid, toid, rules);

    return rules;
};
